// API utility functions - using Railway backend for production
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://vsmp-web-production.up.railway.app';

export const createPaymentSession = async (data) => {
  const url = API_BASE_URL ? `${API_BASE_URL}/api/create-payment-session` : '/api/create-payment-session';
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data)
  });

  if (!response.ok) {
    throw new Error('Failed to create payment session');
  }

  return await response.json();
};

export const saveDonation = async (data) => {
  const url = API_BASE_URL ? `${API_BASE_URL}/api/save-donation` : '/api/save-donation';
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data)
  });

  if (!response.ok) {
    throw new Error('Failed to save donation');
  }

  return await response.json();
};

export const checkPaymentStatus = async (orderId) => {
  const url = API_BASE_URL ? `${API_BASE_URL}/api/payment-status?orderId=${orderId}` : `/api/payment-status?orderId=${orderId}`;
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error('Failed to check payment status');
  }

  return await response.json();
};
